const CHUNK_RELOAD_KEY = "mente-sa-chunk-reload";
const CACHE_BUST_PARAM = "__app_refresh";
const RELOAD_COOLDOWN_MS = 30_000;

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|Loading chunk|Loading CSS chunk|Importing a module script failed|error loading dynamically imported module|módulo da aplicação não foi carregado corretamente|Cannot read properties of undefined \(reading ['"]default['"]\)/i;

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";

  return CHUNK_ERROR_PATTERN.test(message);
}

export function reloadWithFreshAssets(): boolean {
  if (!navigator.onLine) return false;

  const now = Date.now();
  const previousReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (now - previousReload < RELOAD_COOLDOWN_MS) return false;

  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  const url = new URL(window.location.href);
  url.searchParams.set(CACHE_BUST_PARAM, String(now));
  // Remove o service worker e as caches antes de recarregar, para nunca ficar preso numa versão antiga.
  const cleanup: Promise<unknown>[] = [];
  if ("serviceWorker" in navigator) cleanup.push(navigator.serviceWorker.getRegistrations().then((r) => Promise.all(r.map((x) => x.unregister()))));
  if ("caches" in window) cleanup.push(caches.keys().then((k) => Promise.all(k.map((x) => caches.delete(x)))));
  Promise.allSettled(cleanup).finally(() => window.location.replace(url.toString()));
  return true;
}

export function installChunkRecovery(): void {
  // O service worker atual é conservador (HTML sempre da rede). Só é removido, junto das
  // caches, quando ocorre um erro real de chunk (ver reloadWithFreshAssets / index.html).

  window.addEventListener("vite:preloadError", (event) => {
    // Não chamar preventDefault: isso faria o import() resolver como undefined
    // e o React falharia depois ao tentar ler a propriedade `default`.
    reloadWithFreshAssets();
  });

  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event.error || event.message)) {
      reloadWithFreshAssets();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadWithFreshAssets();
    }
  });
}